import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiHeader} from '../../../../../utlis/commonfunctions';
import swal from 'sweetalert';
import SimpleReactValidator from 'simple-react-validator';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import AddPlanHead from './AddPlanHead';
import Loader from "./loader";

const SERVER_URL = process.env.REACT_APP_API_URL+"add_a_wme_mobile_plan/";




const CheckAccount = ({nextStep, handleSession, commonSession, handleAccountCheck}) => {
    const validator = new SimpleReactValidator();
    const [state, setState] = useState({
        username: '',
        errormsg: '',
        loading: false,
        session_id:null,
        verfied:null
    });


    const mySubmitHandler = async (event) => {
        event.preventDefault();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(state.username)){
            swal("", "Please enter a valid username", 'warning');
            return ;
        }
    
        setState((prevState) => ({ ...prevState, loading: true, errormsg: '', eSIMErrorMsg: '' }));

        const post_data = {
            
            username: state.username
        };

        const headers=await getApiHeader();

        try {
            const response = await axios.post(`${SERVER_URL}verify_username`, post_data, { headers });
            var response_error = true;
            if(response.status===200){
              if(response.data.message !== 'undefined'){
                    //swal(response.data.message, "", 'success');
                    if(response.data.data.SessionId !== 'undefined'){
                    var SessionId = response.data.data.SessionId;
                    var response_error = false;
                    setState((prevState) => ({ session_id: SessionId, verfied:response.data.message}));
                    handleSession(SessionId);
                    handleAccountCheck(response.data.data.accountData);
                    nextStep();
                  }
              }
          }
          setState((prevState) => ({ ...prevState, loading: false }));
          if(response_error===true){ swal("Unexpected error", "Please try again.", 'error'); }

        } catch (error) {
            setState((prevState) => ({ ...prevState, loading: false }));
            if(error.response.data.message != 'undefined'){
                swal("", error.response.data.message, 'warning');
            }else{
                swal("Unexpected error", "Please try again", 'error');
            }
            
        }
    };


    const usernameCheck = (event) => {
        const value = event.target.value;
       
        setState((prevState) => ({ ...prevState, username: value }));
    };
   

    

    return (
        <div>
            <DashboardLayout>
                <DashboardNavbar />
                <AddPlanHead />

                <div className="formbold-main-wrapper add-plan-wrapper">
                    <div className="formbold-form-wrapper add-plan-form pos-rel">

                        {state.loading === true && (
                            <Loader />
                        )}
                        
                        <h6>Verify Account</h6>
                        <hr/>
                        <br/>
                        <form onSubmit={mySubmitHandler} className="ad-mb-form">
                           
                                <div className="col-lg-6">
                                    <label className="formbold-form-label formbold-form-label-2">Enter My Account Username</label>
                                    <input
                                        // type="email"
                                        name="username"
                                        id="en-user"
                                        placeholder="Enter My Account Username"
                                        className="formbold-form-input addInput"
                                        value={state.username}
                                        onChange={usernameCheck}
                                        autoComplete='off'
                                        // required
                                    />
                                    {state.verfied !== null && (
                                        <span className="ad-mp-succ">{state.verfied}</span>
                                    )}
                                </div>
                                <div className="col-lg-6 verify-account">
                                    <br/>
                                    <button className="button btn btn-danger ad-mb-button">Verify to continue</button>
                                </div>

                        </form>
       
                        
                        <br/>
                        <br/>

                    </div>
                </div>
            </DashboardLayout>
        </div>
    );
};

export default CheckAccount;
